import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types.tsx';

const secure = '(/secure/|/)';
export const legacyGinManageRoute: InvariantRoute = {
	name: 'legacy-gin-manage',
	path: `${secure}ManageFilters.jspa`,
};
